import * as React from 'react'
import {Route, Redirect, Switch} from 'react-router-dom'
import {ComponentExt} from '@utils/reactExt'

import {IUserStore} from '@store/store';
import {inject, observer} from 'mobx-react'
import {globalAppRouter} from '@viewsG/router'

interface CRouterProps {
    location?: any
    userStore?: IUserStore
    homeStoreG?: any
}

@inject(...['userStore', 'homeStoreG'])
@observer
export default class CRouter extends ComponentExt<CRouterProps> {
    public routers: any = []
    private userStore
    private homeStoreG

    constructor(props) {
        super(props)
        this.routers = this.buildRouter()
        this.userStore = props.userStore
        this.homeStoreG = props.homeStoreG
        this.homeStoreG.getUserInfo()
    }

    render() {
        this.userStore.setPath(this.props.location.pathname)
        return (
            <Switch>
                {
                    this.routers.map((router, index) =>
                        !!router.redirect ? (
                            <Route
                                key={index}
                                exact
                                path={router.path}
                                render={() => <Redirect to={router.redirect} push/>}
                            />
                        ) : (
                            <Route key={index} path={router.path} component={router.component}/>
                        )
                    )
                }
                <Route render={() => <Redirect to="/404"/>}/>
            </Switch>
        )
    }

    private buildRouter = (): any[] => {
        const newRouter = []
        const hasChid = (obj: PlainObject): boolean => {
            return obj.hasOwnProperty('children') && obj.children.length > 0
        }
        const hasAauth = (obj: PlainObject): boolean => {
            return !obj.hasOwnProperty('authCode')
        }
        const pushArray = (list, path = '') => {
            list.map((item: PlainObject, index) => {
                const router = {...item}
                router.path = `${path}/${router.path}`
                if (hasChid(router)) {
                    router.redirect = `${router.path}/${router.children[0].path}`
                    pushArray(router.children, router.path)
                }
                if (hasAauth(router)) {
                    newRouter.push(router)
                }
            })
        }
        pushArray(globalAppRouter)
        return newRouter
    }
}
